import { createContext } from 'react'

const PermissionSectionContext = createContext()

export { PermissionSectionContext }



// WEBPACK FOOTER //
// ./src/components/changeRequests/permissionSectionContext.js